export enum LobActivitySettingsPermissions {
  AdminSettings = 'admin-settings',
  VoSettings = 'vo-settings',
}
